'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Immutable = require('Immutable');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaults = {
  utm_campaign: null,
  utm_medium: null,
  utm_source: null,
  meeting_funnel: null,
  meeting_product: null,
  meeting_medium: null,
  meeting_type: null,
  meeting_source: null,
  meeting_campaign: null,
  source_app: null
};

var TrackingParams = function (_Record) {
  _inherits(TrackingParams, _Record);

  function TrackingParams() {
    _classCallCheck(this, TrackingParams);

    return _possibleConstructorReturn(this, (TrackingParams.__proto__ || Object.getPrototypeOf(TrackingParams)).apply(this, arguments));
  }

  _createClass(TrackingParams, [{
    key: 'compact',
    value: function compact() {
      return this.reduce(function (truthyFields, fieldValue, fieldName) {
        if (fieldValue) {
          truthyFields[fieldName] = fieldValue;
        }
        return truthyFields;
      }, {});
    }
  }], [{
    key: 'from',
    value: function from(json) {
      return new TrackingParams(json);
    }
  }]);

  return TrackingParams;
}((0, _Immutable.Record)(defaults));

exports.default = TrackingParams;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/models/TrackingParams.js
// module id = 514
// module chunks = 0